import { PueblaPreviousYearsResponse } from 'Services/sat/types';
import { RequestPreviousYearResponse } from 'Services/previousYears/types';
import { history } from 'Store';
import { routes } from 'Constants/routes';
import { TAX_YEAR } from 'Config';
import ResultBox from './components/ResultBox';
import ResultBoxToReturn from './components/ResultBoxToReturn';
import { PreviousYearSatStatus, PreviousYearsResultType, PreviousYearStatus } from './types';

export const resultTypeTexts = {
  TORETURN: {
    title: 'PreviousYears.toReturn.title',
    subtitle: 'PreviousYears.toReturn.subtitle',
    buttonLabel: 'PreviousYears.checkout.button',
    disclaimer: '',
    color: 'green_600',
    type: 'toReturn',
  },
  TOPAY: {
    title: 'Previous.years.result.toPay.title',
    subtitle: 'Previous.years.result.toPay.subtitle',
    buttonLabel: 'PreviousYears.checkout.toPay.button',
    disclaimer: 'PreviousYears.toPay.info',
    color: 'danger-500',
    type: 'toPay',
  },
  ZERO: {
    title: 'Previous.years.result.equal.title',
    subtitle: 'Previous.years.result.equal.subtitle',
    buttonLabel: 'PreviousYears.checkout.equal.button',
    disclaimer: 'PreviousYears.equal.info',
    color: 'moon_500',
    type: 'equal',
  },
  NOT_SUPPORTED: {
    title: 'Previous.years.result.not_supported.title',
    subtitle: 'Previous.years.result.not_supported.subtitle',
    buttonLabel: 'PreviousYears.checkout.not_supported.button',
    disclaimer: 'PreviousYears.not_supported.info',
    color: 'moon_500',
    type: 'not_supported',
  },
};

export const getResultPercentagePA = (result: number): number => {
  const percentage = result * 0.25;
  if (percentage >= 349) {
    return percentage;
  }

  return 349;
};

export const bullets = {
  [PreviousYearsResultType.TO_RETURN]: [
    {
      question: 'PreviousYears.toReturn.first.question',
      answer: 'PreviousYears.toReturn.first.answer',
    },
    {
      question: 'PreviousYears.toReturn.second.question',
      answer: 'PreviousYears.toReturn.second.answer',
    },
    {
      question: 'PreviousYears.toReturn.third.question',
      answer: 'PreviousYears.toReturn.third.answer',
    },
  ],
  [PreviousYearsResultType.ZERO]: [
    {
      question: 'PreviousYears.zero.first.question',
      answer: 'PreviousYears.zero.step.1',
    },
    {
      question: 'PreviousYears.zero.second.question',
      answer: 'PreviousYears.zero.step.2',
    },
  ],
  [PreviousYearSatStatus.NOT_AVAILABLE]: [
    {
      question: 'PreviousYears.not_available.first.question',
      answer: 'PreviousYears.not_available.first.answer',
    },
    {
      question: 'PreviousYears.not_available.second.question',
      answer: 'PreviousYears.not_available.second.answer',
    },
  ],
};
export const acurateBullets = [
  'PreviousYears.step.accurate.1',
  'PreviousYears.step.accurate.2',
  'PreviousYears.step.accurate.3',
];

export const componentsByResult = {
  [PreviousYearsResultType.TO_RETURN]: ResultBoxToReturn,
  [PreviousYearsResultType.ZERO]: ResultBox,
  [PreviousYearsResultType.TO_PAY]: ResultBox,
};

export const redirectToAppropriateRoute = (
  isRequest?: RequestPreviousYearResponse,
  data?: PueblaPreviousYearsResponse
): void => {
  if (!isRequest) return;

  if (isRequest?.isRequested && isRequest?.taxYear !== TAX_YEAR && !data) {
    history.push(routes.DATAGATHERING_FIRST_STEP, { products: { isPreviousYear: true } });
    return;
  }

  if (!data) {
    history.push(routes.DATAGATHERING_LOADER, { products: { isPreviousYear: true } });
    return;
  }

  const { stage, refundStatusType } = data;

  if (stage === PreviousYearStatus.SUBMITTED) {
    history.push(routes.PREVIOUS_YEARS_WORKING, { products: { isPreviousYear: true } });
  } else if (stage === PreviousYearStatus.CALCULATING) {
    if (refundStatusType === PreviousYearsResultType.TO_RETURN) {
      history.push(routes.PREVIOUS_YEARS_CALCULATING_LOADER);
    } else {
      history.push(routes.DATAGATHERING_LOADER, { products: { isPreviousYear: true } });
    }
  } else if (stage === PreviousYearStatus.READY) {
    history.push(routes.PREVIOUS_YEARS);
  }
};
